import { WrittenNumber } from '@/Domain/WrittenNumber/index'
import { WrittenNumberOptions } from '@/Domain/WrittenNumber/WrittenNumberOptions'

export class CurrencyWords {
    private _words: string
    private _props: WrittenNumberOptions
    private _writeNumber: WrittenNumber

    constructor (language: string, amount: number | string) {
      this._props = new WrittenNumberOptions(language.toLocaleLowerCase())

      this._writeNumber = new WrittenNumber(this._props)

      const priceTMP = amount.toString().split(',')
      const priceUnit = this._writeNumber.writtenNumber(parseInt(priceTMP[0]))
      const priceDec = priceTMP.length > 1 ? this.checkDecimals(priceTMP[1]) : null
      this._words = priceDec !== null ? priceUnit + ' con ' + priceDec : priceUnit
    }

    private checkDecimals (dec: string): string {
      if (dec.startsWith('0')) {
        return ('cero ' + this._writeNumber.writtenNumber(parseInt(dec)))
      } else { return this._writeNumber.writtenNumber(parseInt(dec)) }
    }

    private capitalizeFirstLetter (word: string): string {
      return (word.charAt(0).toUpperCase() + word.slice(1))
    }

    toString (): string {
      return this.capitalizeFirstLetter(this._words)
    }
}
